import { render, staticRenderFns } from "./platAccountModal.vue?vue&type=template&id=47763d6e&scoped=true"
import script from "./platAccountModal.vue?vue&type=script&lang=js"
export * from "./platAccountModal.vue?vue&type=script&lang=js"
import style0 from "./platAccountModal.vue?vue&type=style&index=0&id=47763d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47763d6e",
  null
  
)

export default component.exports